import { DeleteIcon, IconWrapper, PlayIcon } from "common/components/icon";
import { DefaultButton } from "./DefaultButton";
import { colors } from "common/const/colors";
import styled from "styled-components";

export const ImagePreview = ({
  width,
  height,
  borderColor,
  src,
  thumbnail,
  isVideo,
  showPlayButton = false,
  onClick,
  showDeleteButton,
  onDelete,
  children,
}) => {
  const displaySrc = isVideo ? (thumbnail ?? undefined) : src;

  return (
    <PreviewButton
      width={width}
      height={height}
      borderColor={borderColor}
      src={displaySrc}
      onClick={onClick}>
      {isVideo && !thumbnail && (
        <video
          src={src}
          playsInline
          preload="metadata"
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
            pointerEvents: "none",
          }}
        />
      )}
      {isVideo && showPlayButton && (
        <PlayButtonWrapper size="3rem">
          <PlayIcon color={colors.White} />
        </PlayButtonWrapper>
      )}
      {showDeleteButton && (
        <DeleteButtonWrapper onClick={onDelete}>
          <DeleteIcon color={colors.White} />
        </DeleteButtonWrapper>
      )}
      {children}
    </PreviewButton>
  );
};

const PlayButtonWrapper = styled(IconWrapper)`
  background-color: ${colors.withOpacity(colors.Black, 0.5)};
  border-radius: 50%;
  z-index: 1;
`;

const DeleteButtonWrapper = styled(IconWrapper)`
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  padding: 0.5rem;
  background-color: ${colors.withOpacity(colors.Black, 0.25)};
  border-radius: 50%;
`;

const PreviewButton = styled(DefaultButton)`
  position: relative;
  border: none;
  overflow: hidden;

  &:active:not(:has(${DeleteButtonWrapper}:active)) ${PlayButtonWrapper} {
    opacity: 0.8;
  }
`;
